<!-- ==================== GENERIC DROPDOWN COMPONENT ====================
     Renders a trigger button (custom content via #trigger) and, when open,
     an option list (custom content per option via #option). -->
<div class="app-dropdown">
    <!-- Trigger button: opens/closes the panel -->
    <button type="button" class="app-dropdown-trigger" (click)="toggle($event)">
        @if (triggerTemplate) {
            <!-- Consumer's custom trigger content; receives the current `selected` value as $implicit -->
            <ng-container *ngTemplateOutlet="triggerTemplate; context: { $implicit: selected }"></ng-container>
        }
        <i class="pi pi-chevron-down app-dropdown-caret" [class.app-dropdown-caret--open]="isOpen()"></i>
    </button>

    <!-- Option list, only rendered while open -->
    @if (isOpen()) {
        <ul class="app-dropdown-panel">
            @for (option of options; track trackBy(option)) {
                <!-- Highlights the option matching `selected` -->
                <li class="app-dropdown-option" [class.app-dropdown-option--active]="isActive(option)" (click)="select(option)">
                    @if (optionTemplate) {
                        <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: option }"></ng-container>
                    }
                </li>
            }
        </ul>
    }
</div>
